<app-page-shell variant="default" [embedded]="isModal()">
<!-- Add User Section  Start -->
  <app-sb-input-form
    [mode]="platformId() ? 'edit' : 'add'"
    [title]="(platformId() ? 'Update' : 'Add') + ' Registration Platform'"
    submitLabel="Save"
    [stickyFooter]="!isModal()"
    [embedded]="isModal()"
    (submitted)="saveRegistrationPlatform()"
    (cancelled)="cancelClick()">
        <div class="form-wraper" [formGroup]="addRegistrationPlatformForm">
            <div class="row align-items-center">
              <div class="col-lg-4 ">
                <app-sb-input-image
                  formControlName="image"
                  label="Logo"
                  [autoUpload]="true"
                  [showFileBrowser]="false"
                  accept="jpg,jpeg,png,webp"
                  [minWidth]="150"
                  [minHeight]="150"
                  [maxWidth]="2048"
                  [maxHeight]="2048"
                  [maxFileSize]="5242880">
                </app-sb-input-image>
              </div>
              <div class="col-lg-8 col-md-12 col-ms-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="floating-label">
                      <input  (blur)="!this.platformId() && generateSlug();!this.platformId() && validateSlug();" formControlName="name" placeholder=" "
                             required="required" class="floating-input"
                             type="text" autocomplete="off"/>
                      <label>Name <span class="red">*</span>
                      </label>
                      @if (submitted && f.name.errors) {
                      <div class="bar error-brd">
                        @if (f.name.errors.required) {
                        <div class="invalid-text">Platform name is required</div>
                        }
                      </div>
                      }

                    </div>

                  </div>
                  @if (!this.platformId()) {
                  <div class="col-lg-6">
                    <div class="floating-label flex-wrap info-input">
                      <input
                        (blur)="validateSlug()"
                        [class.is-invalid]="submitted && f.slug.errors"
                        class="floating-input slugInput"
                        formControlName="slug"
                        placeholder=" "
                        required="required"
                        type="text"
                      />
                      <span class="highlight"></span>
                      <label
                      >Platform's Slug
                        <span class="red">*</span>
                      </label>
                      @if (submitted && f.slug.errors) {
                      <div
                        class="bar error-brd"
                      >
                        @if (f.slug.errors.required) {
                        <div
                          class="invalid-text"
                        >
                          Platform's Slug is required
                        </div>
                        }
                      </div>
                      }
                      <app-info-popover
                        info="This is a unique key for this Platform.">
                      </app-info-popover>
                    </div>
                  </div>
                  }

                  <div class="col-md-6">
                    <div class="floating-label">
                      <input formControlName="website" placeholder=" "
                             required="required" class="floating-input"
                             type="text" autocomplete="off"/>
                      <label>Website <span class="red">*</span>
                      </label>
                      @if (submitted && f.website.errors) {
                      <div class="bar error-brd">
                        @if (f.website.errors.required) {
                        <div class="invalid-text">Website name is required</div>
                        }
                        @if (f.website.errors !== null && !f.website.errors.required) {
                        <div class="invalid-text">Please enter valid Website name</div>
                        }
                      </div>
                      }
                    </div>
                  </div>

                  <div class="col-md-6">
                    <app-creatable-select
                      [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                      [placeholder]="'Select Widget Support'" [selectOptions]="widgetSupportValues"
                      [selectedValue]="selectedWidgetSupport"
                      (optionSelected)="setWidgetSupport($event)"
                      ></app-creatable-select>
                  </div>
                  <div class="col-md-6">
                    <app-creatable-select
                      [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                      [selectedValue]="selectedSyncSupport"
                      [placeholder]="'Select Sync Support'" [selectOptions]="syncSupportValues"
                      (optionSelected)="setSyncSupport($event)"
                    ></app-creatable-select>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-ms-12">
                <div class="floating-label floating-code-label">
                      <textarea  formControlName="settings" class="form-control floating-input"
                                 placeholder=" " type="text" rows="7">
                      </textarea>
                  <label>Settings</label>
                </div>
              </div>
              <div class="col-lg-8 col-md-8 col-ms-8">
                <input formControlName="supports_push_links" placeholder="" type="checkbox" class='me-2' (change)="onChangeCheckbox($event, 'supports_push_links')">
                <label class="widget-integration-css">Supports two-way sync</label>
              </div>
              <div class="col-lg-12 col-md-12 col-ms-12">
                <app-sb-input-textarea label="Widget Integration Guide" formControlName="widget_integration_guide"
                  [wysiwyg]="true" [autoHeight]="true" [showFileBrowser]="true"></app-sb-input-textarea>
              </div>

              <div class="col-lg-12 col-md-12 col-ms-12 mt-2">
                <app-sb-input-textarea label="Api Integration Guide" formControlName="api_integration_guide"
                  [wysiwyg]="true" [autoHeight]="true" [showFileBrowser]="true"></app-sb-input-textarea>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-ms-12 p-0 mt-3">
              <input formControlName="hide_default_guide" placeholder="" type="checkbox" class='me-2' (change)="onChangeCheckbox($event, 'hide_default_guide')">
              <label class="widget-integration-css">Hide Default Guide</label>
            </div>
            <div class="col-lg-12 col-md-12 col-ms-12 p-0">
              <div class="floating-label floating-code-label">
                      <textarea  formControlName="widget_customization_code" class="form-control floating-input"
                                placeholder=" " type="text" rows="7">
                      </textarea>
                <label>Widget v2 Customization Code</label>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-ms-12 p-0">
              <div class="floating-label floating-code-label">
                      <textarea  formControlName="widget_customization_css" class="form-control floating-input"
                                placeholder=" " type="text" rows="7">
                      </textarea>
                <label>Widget v2 Customization CSS</label>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-ms-12 p-0">
              <div class="floating-label floating-code-label">
                      <textarea formControlName="widget_customization_code_old" class="form-control floating-input"
                                placeholder=" " type="text" rows="7">
                      </textarea>
                <label>Widget v1 Customization Code</label>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 col-ms-12 p-0">
              <div class="floating-label floating-code-label">
                      <textarea formControlName="widget_customization_css_old" class="form-control floating-input"
                                placeholder=" " type="text" rows="7">
                      </textarea>
                <label>Widget v1 Customization CSS</label>
              </div>
            </div>
        </div>
  </app-sb-input-form>
</app-page-shell>
